import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import TextField from 'material-ui/TextField'
import Checkbox from 'material-ui/Checkbox'
import Divider from 'material-ui/Divider'
import DatePicker from 'material-ui/DatePicker'

import { getTimezoneDate } from 'utils/date'
import { getMonth } from 'utils/date'

import TenantCombobox from 'components/TenantCombobox'
import ManagerSelect from 'components/ManagerSelect'
import Tasks from './tasks'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import { tasksByProjectID } from 'selectors/tasks'
import { projectStatus } from 'selectors/projects'
import { properties } from 'selectors/entities'

let select = dirtyRead(
	(state, props) => ({
		project: projectStatus(tasksByProjectID(state))(doc(state, props.projectID))
	  , properties: properties(state)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		return(
			<div
				key={props.project.title}
				className="left-side"
				style={{
					 width: (props.countColomns>1)?"50%":"100%"
   				   , overflowY: (props.countColomns>1)?"scroll":"auto"
				   , overflowX: "hidden"
				}}
			>
				<div style={{paddingLeft: "20px", boxShadow: "rgba(0, 0, 0, 0.298039) 0px 1px 1px", background: "#FFF"}}>
					<div className="project-name" style={{display: "flex"}}>
						<Checkbox
							disabled={(props.project.projectStatus == 'open')? true: false}
							iconStyle={{
								fill: (props.project.status == 'Open')?"#000":"#00d4b3"
							  , transform: "scale(1.2)"
							}}
							style={{
								width: "auto"
							  , marginTop: "12px"
							}}
							checked={!(props.project.status == 'Open')}
							onClick={() => {
								props.STAGE({
									_id: props.project._id
								  , status: (props.project.status == "Open")? "Closed" : "Open"
								})
							}}
						/>
						<TextField style={{position: "relative", width: "calc(100% - 104px)"}}
							id="project-title"
							hintText = "Project title"
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							multiLine = {true}
							fullWidth={false}
							style={{
								width: "100%"
							  , marginLeft: "7px"
							}}
							inputStyle={{
								fontSize: "16px"
							  , fontWeight: "bold"
							}}
							underlineStyle={{
								left: "1px"
							  , borderBottom: "0px solid #b0bec4"
							}}
							defaultValue={props.project.title}
							key={`${props.project._id}-title`}
							onBlur={(evt)=>{
								(evt.target.value.length)?
									props.STAGE({
										_id: props.project._id
									  , title: evt.target.value
									})
									: false
								}
							}
						/>
					</div>
					<div className="project-property">
						{ (props.project.isForAll || !props.project.propertyID)?
							<p
								style={{
									marginTop: "0px"
								  , marginBottom: "0px"
								}}
							>
								<svg
									viewBox="0 0 90 90"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									xmlnsXlink="http://www.w3.org/1999/xlink"
									className="left-navigation-icons"
									style={{float: "left", position: "relative"
										, height: "24px", marginLeft: "3px"
									}}
								>
									<title>properties</title>
									<defs></defs>
									<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
										<g id="properties" fill="#3cd2ae">
											<path d="M77.249,34.53 L40.426,1.599 C40.362,1.542 40.292,1.498 40.223,1.451 C39.497,0.745 38.342,0.703 37.575,1.389 L0.751,34.321 C-0.05,35.037 -0.119,36.268 0.598,37.069 C0.982,37.499 1.515,37.718 2.049,37.718 C2.511,37.718 2.974,37.555 3.345,37.222 L10.356,30.952 L10.356,32.61 L10.356,49.802 L10.356,69.865 C10.356,72.754 12.706,75.104 15.595,75.104 C15.639,75.104 15.681,75.094 15.724,75.091 C15.768,75.094 15.809,75.104 15.853,75.104 L27.22,75.104 C29.79,75.104 31.881,73.11 32.085,70.592 C32.111,70.465 32.125,70.334 32.125,70.199 L32.125,50.679 C32.125,50.121 32.579,49.667 33.137,49.667 L44.864,49.667 C45.422,49.667 45.876,50.121 45.876,50.679 L45.876,70.199 C45.876,70.334 45.89,70.465 45.916,70.592 C46.12,73.11 48.211,75.104 50.781,75.104 L62.405,75.104 C65.343,75.104 67.644,72.19 67.644,68.471 L67.644,50.583 L67.644,45.103 L67.644,31.161 L74.655,37.431 C75.026,37.763 75.49,37.927 75.952,37.927 C76.486,37.927 77.019,37.708 77.403,37.278 C78.119,36.477 78.05,35.247 77.249,34.53 L77.249,34.53 Z M63.751,45.103 L63.751,50.583 L63.751,68.47 C63.751,70.17 62.879,71.211 62.404,71.211 L50.78,71.211 C50.222,71.211 49.768,70.757 49.768,70.199 L49.768,50.679 C49.768,47.975 47.568,45.775 44.864,45.775 L33.137,45.775 C30.433,45.775 28.233,47.975 28.233,50.679 L28.233,70.199 C28.233,70.757 27.779,71.211 27.221,71.211 L15.854,71.211 C15.81,71.211 15.768,71.221 15.725,71.224 C15.681,71.221 15.64,71.211 15.596,71.211 C14.853,71.211 14.249,70.607 14.249,69.864 L14.249,49.801 L14.249,32.609 L14.249,27.47 L38.883,5.44 L63.752,27.68 L63.752,45.103 L63.751,45.103 Z" id="Shape"></path>
										</g>
									</g>
								</svg>
								<span
									style={{
										verticalAlign: "super"
										, marginLeft: "19px"
									}}
								>
									This project is for all properties
								</span>
							</p>
							:
							<Link
								to={`/manager/property/${props.project.propertyID}`}
								style={{
									textDecoration: 'none'
								  , color: 'inherit'
								}}
							>
								<p
									style={{
										marginTop: "0px"
									  , marginBottom: "0px"
									}}
								>
									<svg
										viewBox="0 0 90 90"
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										xmlnsXlink="http://www.w3.org/1999/xlink"
										className="left-navigation-icons"
										style={{float: "left", position: "relative"
											, height: "24px", cursor: "pointer", marginLeft: "2px", marginRight: "3px"
										}}
									>
										<title>properties</title>
										<defs></defs>
										<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											<g id="properties" fill="#3cd2ae">
												<path d="M77.249,34.53 L40.426,1.599 C40.362,1.542 40.292,1.498 40.223,1.451 C39.497,0.745 38.342,0.703 37.575,1.389 L0.751,34.321 C-0.05,35.037 -0.119,36.268 0.598,37.069 C0.982,37.499 1.515,37.718 2.049,37.718 C2.511,37.718 2.974,37.555 3.345,37.222 L10.356,30.952 L10.356,32.61 L10.356,49.802 L10.356,69.865 C10.356,72.754 12.706,75.104 15.595,75.104 C15.639,75.104 15.681,75.094 15.724,75.091 C15.768,75.094 15.809,75.104 15.853,75.104 L27.22,75.104 C29.79,75.104 31.881,73.11 32.085,70.592 C32.111,70.465 32.125,70.334 32.125,70.199 L32.125,50.679 C32.125,50.121 32.579,49.667 33.137,49.667 L44.864,49.667 C45.422,49.667 45.876,50.121 45.876,50.679 L45.876,70.199 C45.876,70.334 45.89,70.465 45.916,70.592 C46.12,73.11 48.211,75.104 50.781,75.104 L62.405,75.104 C65.343,75.104 67.644,72.19 67.644,68.471 L67.644,50.583 L67.644,45.103 L67.644,31.161 L74.655,37.431 C75.026,37.763 75.49,37.927 75.952,37.927 C76.486,37.927 77.019,37.708 77.403,37.278 C78.119,36.477 78.05,35.247 77.249,34.53 L77.249,34.53 Z M63.751,45.103 L63.751,50.583 L63.751,68.47 C63.751,70.17 62.879,71.211 62.404,71.211 L50.78,71.211 C50.222,71.211 49.768,70.757 49.768,70.199 L49.768,50.679 C49.768,47.975 47.568,45.775 44.864,45.775 L33.137,45.775 C30.433,45.775 28.233,47.975 28.233,50.679 L28.233,70.199 C28.233,70.757 27.779,71.211 27.221,71.211 L15.854,71.211 C15.81,71.211 15.768,71.221 15.725,71.224 C15.681,71.221 15.64,71.211 15.596,71.211 C14.853,71.211 14.249,70.607 14.249,69.864 L14.249,49.801 L14.249,32.609 L14.249,27.47 L38.883,5.44 L63.752,27.68 L63.752,45.103 L63.751,45.103 Z" id="Shape"></path>
											</g>
										</g>
									</svg>
									<span
										style={{
											verticalAlign: "super"
											, marginLeft: "19px"
										  	, textDecoration: "underline"
										}}
									>
										{props.properties[props.project.propertyID].alias}
									</span>
								</p>
							</Link>
						}
					</div>
					{ (!props.project.isForAll || props.project.propertyID)?
						<TenantCombobox objectID={props.projectID} />
						:
						""
					}
					<ManagerSelect objectID={props.projectID} />
					<div style={{margin: "-5px 0 0 4px", display:"inline-block", width: "45px"}}>
						<img
							src={".." + "/static/img/calendar-green.png"}
							style={{
							  width: "20px"
							, position: "relative"
							, top: "3px"
							}}
						/>
					</div>
					<div style={{margin: "0px", display:"inline-block", width: "40%"}}>
						<p style={{marginTop: "0px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
						Created on</p>
						<DatePicker
							style={{
								color: "#000"
							}}
							disabled={true}
							textFieldStyle={{
								fontSize: "16px"
								, width: "100px"
								, height: "36px"
								, color: "#000"
							}}
							underlineStyle={{
								borderBottom: "0px solid"
							}}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							hintText="Select"
							formatDate= {(date)=>{
								//debugger
								if (!date || date.toString()=="Invalid Date") return ""
								return getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
							}
							hintStyle={{top: "8px"}}
							style={{width: "100px", height: "35px", marginTop: "8px"}}
							value={(props.project.date || props.project.createdAt)?getTimezoneDate(props.project.date || props.project.createdAt):""}
						/>
					</div>

					<div style={{margin: "0px", display:"inline-block", width: "40%"}}>
						<p style={{marginTop: "0px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
						Closed on</p>
						<DatePicker
							style={{
								color: "#000"
							}}
							disabled={true}
							textFieldStyle={{
								fontSize: "16px"
								, width: "100px"
								, height: "36px"
								, color: "#000"
							}}
							underlineStyle={{
								borderBottom: "0px solid"
							}}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							hintText="Select"
							formatDate= {(date)=>{
								if (props.project.status !== "Closed") return ""
								return getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
							}
							hintStyle={{top: "8px"}}
							style={{width: "100px", height: "35px", marginTop: "8px"}}
							value={(props.project.updatedAt)?getTimezoneDate(props.project.updatedAt):""}
						/>
					</div>


					<TextField style={{position: "relative", width: "calc(100% - 104px)"}}
						id="task-description"
						floatingLabelText="Description"
						hintStyle={{fontStyle: "italic", fontSize: "14px"}}
						fullWidth={false}
						multiLine={true}
						style={{
							width: "calc(85%)"
						  , position: "relative"
						  , marginTop: "-15px"
						  , marginLeft: "50px"
						}}
						inputStyle={{
							fontSize: "16px"
						  , fontWeight: "bold"
						}}
						underlineStyle={{
							left: "1px"
						  , borderBottom: "0px solid #b0bec4"
						}}
						floatingLabelStyle={{
							fontWeight: "100",
							fontSize: "14px"
						}}
						defaultValue={props.project.description || ""}
						key={props.project.description}
						onBlur={(evt)=>{
							props.STAGE({_id: props.projectID, description: evt.target.value})
						}}
					/>
				</div>

				<Tasks projectID={props.projectID} />
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/manager/projectForm/LeftSide.js